import { render, staticRenderFns } from "./ExperianLogo.vue?vue&type=template&id=6346b8c4&scoped=true"
import script from "./ExperianLogo.vue?vue&type=script&lang=js"
export * from "./ExperianLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6346b8c4",
  null
  
)

export default component.exports